import {
  FETCH_IMPORT_HISTORY_STATUS_SUCCESS,
  FETCH_IMPORT_HISTORY_SUCCESS,
  FETCHING_IMPORT_HISTORY_SUCCESS
} from './ImportHistoryConstants';

const initialState = {
  importHistoryData: [],
  fetchingImportHistory: false,
  importHistoryStatusData: [],
  pageState: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  }
};

const ImportHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IMPORT_HISTORY_SUCCESS:
      return { ...state, importHistoryData: action.importHistoryData, fetchingImportHistory: false, pageState: action.pageState };
    case FETCH_IMPORT_HISTORY_STATUS_SUCCESS:
      return { ...state, importHistoryStatusData: action.importHistoryStatusData };
    case FETCHING_IMPORT_HISTORY_SUCCESS:
      return { ...state, fetchingImportHistory: true };
    default:
      return state;
  }
};

export default ImportHistoryReducer;



// WEBPACK FOOTER //
// ./src/redux/importHistory/ImportHistoryReducer.js